module.exports = __webpack_public_path__ + "5ddc7fbb889fdd6046bb07a80d978ac8.svg";